require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.2@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 138
// module chunks = 0